<template>
  <div>
    <div v-if="currentIndex === 0 && popUpIsShowing" class="second-popup">
      <div class="box">
        <h3 class="tooltip-title">{{ $localize('clue.first.step.main') }}</h3>
        <a @click="close" class="icon icon-close"></a>
        <h3 class="tooltip-title">{{ $localize('clue.first.step.title') }}</h3>
        <div class="next">
          <a @click="next">{{ $localize('clue.first.step.start') }}</a>
          <span class="icon icon-next"></span>
        </div>
      </div>
    </div>
    <div v-if="currentIndex === 1 && popUpIsShowing" class="second-popup">
      <div class="tooltip-box first">
        <a @click="close" class="icon icon-close"></a>
        <h3 class="tooltip-title">{{ $localize('clue.second.step.title') }}</h3>
        <p class="tooltip-text">{{ $localize('clue.second.step.text') }}</p>
        <div class="box-buttons">
          <div class="back">
            <span class="icon icon-back"></span>
            <a @click="previous">{{ $localize('clue.step.back') }}</a>
          </div>
          <div class="next">
            <a @click="next(); $emit('scrollDown')">{{ $localize('clue.step.next') }}</a>
            <span class="icon icon-next"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentIndex === 2 && popUpIsShowing" class="second-popup">
      <div class="tooltip-box second">
        <a @click="close" class="icon icon-close"></a>
        <h3 class="tooltip-title">{{ $localize('clue.third.step.title') }}</h3>
        <p class="tooltip-text">{{ $localize('clue.third.step.text') }}</p>
        <div class="box-buttons">
          <div class="back">
            <span class="icon icon-back"></span>
            <a @click="previous">{{ $localize('clue.step.back') }}</a>
          </div>
          <div class="next">
            <a @click="next">{{ $localize('clue.step.next') }}</a>
            <span class="icon icon-next"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentIndex === 3 && popUpIsShowing" class="second-popup">
      <div class="tooltip-box third">
        <a @click="close" class="icon icon-close"></a>
        <h3 class="tooltip-title">{{ $localize('clue.fourth.step.title') }}</h3>
        <p class="tooltip-text">{{ $localize('clue.fourth.step.text') }}</p>
        <div class="box-buttons">
          <div class="back">
            <span class="icon icon-back"></span>
            <a @click="previous">{{ $localize('clue.step.back') }}</a>
          </div>
          <div class="next">
            <a @click="next">{{ $localize('clue.step.next') }}</a>
            <span class="icon icon-next"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentIndex === 4 && popUpIsShowing" class="second-popup">
      <div class="tooltip-box fourth">
        <a @click="close" class="icon icon-close"></a>
        <h3 class="tooltip-title">{{ $localize('clue.fifth.step.title') }}</h3>
        <p class="tooltip-text">{{ $localize('clue.fifth.step.text') }}</p>
        <div class="box-buttons">
          <div class="back">
            <span class="icon icon-back"></span>
            <a @click="previous">{{ $localize('clue.step.back') }}</a>
          </div>
          <div class="next">
            <a @click="next">{{ $localize('clue.step.next') }}</a>
            <span class="icon icon-next"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentIndex === 5 && popUpIsShowing" class="second-popup">
      <div class="tooltip-box fifth">
        <a @click="close" class="icon icon-close"></a>
        <h3 class="tooltip-title">{{ $localize('clue.sixth.step.title') }}</h3>
        <p class="tooltip-text">{{ $localize('clue.sixth.step.text') }}</p>
        <div class="box-buttons">
          <div class="back">
            <span class="icon icon-back"></span>
            <a @click="previous">{{ $localize('clue.step.back') }}</a>
          </div>
          <div class="next">
            <a @click="next">{{ $localize('clue.step.next') }}</a>
            <span class="icon icon-next"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentIndex === 6 && popUpIsShowing" class="second-popup">
      <div class="tooltip-box sixth">
        <a @click="close" class="icon icon-close"></a>
        <h3 class="tooltip-title">{{ $localize('clue.seventh.step.title') }}</h3>
        <p class="tooltip-text">{{ $localize('clue.seventh.step.text') }}</p>
        <div class="box-buttons">
          <div class="back">
            <span class="icon icon-back"></span>
            <a @click="previous">{{ $localize('clue.step.back') }}</a>
          </div>
          <div class="next">
            <a @click="close(); resolveUserTutorial()">{{ $localize('clue.step.done') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useMainStore } from '@/store/mainStore';

export default {
  emits: ['scrollDown'],
  setup() {
    const currentIndex = ref(0);
    const currentItem = ref(0);
    const popUpIsShowing = ref(true);
    const mainStore = useMainStore();

    function next() {
      if (currentIndex.value === currentItem.value) {
        currentIndex.value += 1;
        currentItem.value += 1;
      }
    }

    function previous() {
      if (currentIndex.value > 0) {
        currentIndex.value -= 1;
        currentItem.value -= 1;
      }
    }

    async function resolveUserTutorial() {
      mainStore.fetchUserTutorialInfo()
        .then((response) => {
          if (response.success) {
            mainStore.$patch((state) => {
              state.user.showTutorial = false;
            });
          }
        });
    }
    function close() {
      popUpIsShowing.value = false;
      mainStore.$patch((state) => {
        state.user.showTutorial = false;
      });
      resolveUserTutorial();
    }

    return {
      currentIndex,
      currentItem,
      next,
      previous,
      popUpIsShowing,
      close,
      resolveUserTutorial,
    };
  },
};
</script>
<style lang="sass" scoped>
.first-popup
  background: #fafaff
  width: 100%
  height: 100%
  position: fixed
  top: 0
  left: 0
  z-index: 125
.box
  width: 67%
  border: 1px #FFF solid
  border-radius: 10px
  padding: 20px
  display: flex
  align-items: center
  flex-direction: column
  text-align: center
  background: #fff
  margin: 35% auto 0
  position: relative
.main-title
  font-style: normal
  font-weight: 700
  font-size: 16px
  text-align: center
  color: #000000
  margin-top: 20%
  margin-bottom: 20%
.tooltip-title
  font-style: normal
  font-weight: 700
  font-size: 22px
  text-align: center
  color: #000000
  margin-top: 20px
  line-height: 24px
  margin: 2px 0 16px 0
.tooltip-text
  margin: 0 0 16px 0
  text-align: center
  line-height: 20px
  font-size: 17px
.icon-close
  color: #000
  right: 6px
  top: 6px
  font-size: 10px
  position: absolute
.second-popup
  width: 100%
  height: 100%
  position: fixed
  top: 0
  left: 0
  z-index: 125
  background: rgba(0, 0, 0, 0.5)

.tooltip-box
  position: relative
  width: 67%
  border: 1px #FFF solid
  border-radius: 10px
  padding: 10px 16px 4px 16px
  display: flex
  align-items: center
  flex-direction: column
  text-align: center
  background: #fff
  margin: 0 auto

  &::after
    content: ""
    position: absolute
    top: 100%
    transform: rotate(180deg)
    left: 50%
    margin-left: -5px
    border-width: 18px
    border-style: solid
    border-color: transparent transparent white transparent

  &::before
    content: attr(title)
    position: absolute
    top: -30px
    left: 50%
    transform: translateX(-50%)
    background-color: white
    color: black
    padding: 8px
    border-radius: 4px
    font-size: 14px
    line-height: 1.4
    white-space: nowrap
    z-index: 1
    opacity: 0
    transition: opacity 0.3s ease-in-out

.box-buttons
  width: 100%
  display: flex
  justify-content: space-between
  margin-bottom: 2px

.first
  position: absolute
  bottom: 10%
  right: 3%
  &:after
    margin-left: 8px
.second
  position: absolute
  bottom: 24%
  right: 3%
  &:after
    margin-left: 22px
.third
  position: absolute
  bottom: 24%
  left: 3%
  &:after
    margin-left: -59px
.fourth
  position: absolute
  bottom: 10%
  left: 3%
  &:after
    margin-left: -44px
.fifth
  position: absolute
  bottom: 10%
  left: 18%
  &:after
    margin-left: -25px
.sixth
  position: absolute
  bottom: 10%
  right: 3%
  &:after
    margin-left: 8px
.back,
.next
  display: flex
  align-items: center
  margin-left: -10px
  margin-right: -10px
.back a,
.next a
  margin: 0 4px
.back span,
.next span
  color: #158AD2
  display: flex
  align-items: center
.icon
  font-size: 14px
.icon-close
  font-size: 12px
</style>
